// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Label-module-label-2sjCu{font-size:12px;color:#5c615e;grid-area:label;display:flex;align-items:center;line-height:1.3}.Label-module-labelCaption-oZJ5s{font-size:12px;color:#5c615e}", ""]);
// Exports
exports.locals = {
	"label": "Label-module-label-2sjCu",
	"labelCaption": "Label-module-labelCaption-oZJ5s"
};
module.exports = exports;
